import React, { Component } from "react";
import Link from "gatsby-link";
import styled from "styled-components";

import colors from "../../styles/colors";

const format = x => x.replace(/_/g, " ");

const Li = styled.li`
  list-style: none;
  left: 0px;
  padding-bottom: 8px;
  padding-left: 15px;
  padding-top: 8px;
  position: relative;
  top: 0px;
  cursor: pointer;
  &.nav-list-item-depth-0 {
    border-bottom: 1px solid ${colors.border};
  }
  > ul {
    display: ${props => (props.showChildren ? "block" : "none")};
  }
  @media screen and (min-width: 900px) {
    display: inline-block;
    padding: 0.5em 15px 0.6em 15px;
    position: relative;
    white-space: nowrap;
    cursor: default;
    z-index: 10;
    > ul {
      display: block;
      left: -9999px;
      list-style: none;
      opacity: 0;
      position: absolute;
      transform: translateX(-50%);
      background-color: ${colors.background};
      border: 1px solid ${colors.border};
      padding: 6px 0px;
      transition: opacity 0.3s ease;
      &:before {
        content: "";
        position: absolute;
        top: -10px;
        left: 50%;
        transform: translateX(-50%);
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 10px solid ${colors.border};
      }
      &:after {
        content: "";
        position: absolute;
        top: -9px;
        left: 50%;
        transform: translateX(-50%);
        border-left: 9px solid transparent;
        border-right: 9px solid transparent;
        border-bottom: 9px solid white;
      }
    }
    &:hover,
    &:active {
      & > ul {
        left: 50%;
        opacity: 1;
        transform: translateX(-50%);
        top: 100%;
      }
    }
    &.nav-list-item-depth-0 {
      border: none;
      float: left;
      padding: 0.4em 15px 1.2em 15px;
    }
    &.nav-list-item-depth-1,
    &.nav-list-item-depth-2,
    &.nav-list-item-depth-3 {
      margin-bottom: 0px;
      padding-bottom: 8px;
      display: block;
      position: relative;
      > ul {
        left: -9999px;
        top: -7px;
        transform: none;
        &:before {
          content: "";
          position: absolute;
          top: 19px;
          left: calc(-20px);
          transform: translateY(-50%);
          border-top: 10px solid transparent;
          border-bottom: 10px solid transparent;
          border-right: 10px solid ${colors.border};
        }
        &:after {
          content: "";
          position: absolute;
          top: 19px;
          left: calc(-18px);
          transform: translateY(-50%);
          border-top: 9px solid transparent;
          border-bottom: 9px solid transparent;
          border-right: 9px solid ${colors.background};
        }
      }
      &:hover,
      &:active {
        > ul {
          left: 100%;
        }
      }
    }
    &:hover,
    &:active {
      > ul {
        left: 50%;
      }
    }
  }
`;

const StyledLink = styled(Link)`
  position: relative;
  color: ${colors.header};
  text-decoration: none;

  &.current {
    border-bottom: 1px solid ${colors.accent};
    &:hover,
    &:focus {
      border-bottom: 1px solid ${colors.accent};
    }
  }
  &:hover,
  &:focus {
    border-bottom: 1px solid ${colors.main};
  }
`;

export default class NavListItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showChildren: false
    };
    this.toggleChildren = this.toggleChildren.bind(this);
  }

  componentWillReceiveProps(props) {
    const { path, prevPath } = props.path;
    if (path != prevPath) {
      this.setState({ showChildren: false });
    }
  }

  toggleChildren(e, children) {
    e.preventDefault();
    e.stopPropagation();
    if (children) {
      this.setState({ showChildren: !this.state.showChildren });
    }
  }

  render() {
    const { item, children, current } = this.props;
    const { showChildren } = this.state;
    return (
      <Li
        {...this.props}
        onClick={e => this.toggleChildren(e, children)}
        showChildren={showChildren}
      >
        {!children ? (
          <StyledLink className={current ? "current" : ""} to={item.slug}>
            {format(item.name)}
          </StyledLink>
        ) : (
          format(item.name)
        )}
        {children}
      </Li>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Navigation/NavListItem.js